export default __webpack_public_path__ + "static/media/order-black.95a23b20.png";